import { PluginsMetaTab } from "./PluginsMetaTab";

export default PluginsMetaTab;